import { Redirect } from 'react-router-dom';

import { useAppSelector } from 'store';

const AuthGuard = ({ requireAuth, children }) => {
  const { pathname } = window.location;
  const isAuthenticated = useAppSelector((state) => state.user.authenticated);

  if (requireAuth && !isAuthenticated && pathname !== '/login') {
    return (
      <Redirect
        to={{
          pathname: '/login',
          state: { from: pathname },
        }}
      />
    );
  }

  if (!requireAuth && isAuthenticated && pathname !== '/') {
    return <Redirect to={{ pathname: '/', state: { from: pathname } }} />;
  }

  return children;
};

export default AuthGuard;
